{
  "version": 1,
  "asset_id": "4ee8181c-e664-4c50-97be-6fd493bd16ff",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/4ee8181c-e664-4c50-97be-6fd493bd16ff/floral-city-black-shingle-roof-installation-1200w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/4ee8181c-e664-4c50-97be-6fd493bd16ff/floral-city-black-shingle-roof-installation-1200w.avif",
  "original_filename": "floral-city-black-shingle-roof-installation-1200w.avif",
  "size": 54830,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:36Z"
}
